import { render, staticRenderFns } from "./SubmissionConfirmDialog.vue?vue&type=template&id=a62d124e&"
import script from "./SubmissionConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./SubmissionConfirmDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SubmissionConfirmDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports